import React, { Component } from 'react';
import ButtonIcon from '../../button';
import "./button.css";

class DropdownItem extends Component {
    render() {
      const { label, onClick } = this.props;
      return (
        <div className="drop-down-item px-4 py-2 cursor-pointer"
          onClick={() => onClick()}
        >
          {label}
        </div>
      );
    }
  }
  
  class DropdownMenu extends Component {
    render() {
      const { items } = this.props;
      return (
        <div className='dropdown-menu-container'>
             <div className="dropdown-items bg-white border mt-2 rounded shadow-lg w-48">
                {items.map((item, index) => (
                  <DropdownItem key={index} label={item.label} onClick={item.onClick} />
                ))}
              </div>
        </div>
      );
    }
  }
  
  class DropdownButton extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isOpen: false
      };
    }
  
    toggleDropdown = () => {
      this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    };
  
    closeDropdown = () => {
      this.setState({ isOpen: false });
    };
  
    render() {
      const { label, items, customClassName, iconSize } = this.props;
      const { isOpen } = this.state;
  
      return (
        <div className="relative inline-block text-left" onBlur={this.closeDropdown} tabIndex="0">
          <ButtonIcon onClick={this.toggleDropdown} iconSize={iconSize} customClassName={customClassName} labelName={label}/>
          {isOpen && <DropdownMenu items={items} />}
        </div>
      );
    }
  }
  
  export default DropdownButton;